import {NgModule} from '@angular/core';
import {RequirementComponent} from './requirement.component';

@NgModule({
   exports: [RequirementComponent],
   declarations: [RequirementComponent]
})

export class RequirementModule {}